import React, { useState, useEffect } from "react";
import "./About.css";
import { Fade } from "react-awesome-reveal";
import logo from "../assets/gatorhead.png";
import pic1 from "../assets/memberimage1.jpg";
import pic2 from "../assets/memberimage2.jpg";
import pic3 from "../assets/memberimage3.jpg";
// import apps from "../assets/applicationsopen.png";

const About = () => {
  const [size, setSize] = useState(window.innerWidth);
  const [small, setSmall] = useState(false);
  const [smaller, setSmaller] = useState(false);

  const checkSize = () => {
    setSize(window.innerWidth);
  };

  useEffect(() => {
    if (size <= 1250) {
      setSmall(true);
    }
    if (size > 1250) {
      setSmall(false);
    }
    if (size <= 825) {
      setSmaller(true);
    }
    if (size > 825) {
      setSmaller(false);
    }

    window.addEventListener("resize", checkSize);
    return () => {
      window.removeEventListener("resize", checkSize);
    };
  }, [size]);

  return (
    <div className="about-div">
      <div className="about-faux-title"></div>
      <div className="about-title-div">
        <div className="about-divider"></div>
        <Fade triggerOnce>
          <div className="about-title-container">
            <img className="about-image" src={logo} alt="" />
            <h1 className="about-title">About</h1>
          </div>
        </Fade>
        <div className="about-divider"></div>
      </div>
      {/* <div className="about-notification">
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSelRyTBI6DCtqYluwqVay8A2Fy5d55VcXAnI-n2-t76ccSc4g/viewform?pli=1&pli=1"
          target="_blank"
          rel="noopener noreferrer"
          className="about-notification-button"
        >
          Apply now!
        </a>
      </div> */}
      <Fade triggerOnce className="about-constitution-div">
        <h1 className="about-constitution-title-1">Our Purpose</h1>
        <div className="about-constitution-divider"></div>
        <p className="about-constitution-paragraph">
          The First Generation Leadership Program (FGLP) is designed to 
          develop real-world skills within a select cohort of student leaders 
          by providing them with opportunities in the form of our four pillars: 
          mentorship, professionalism, community service, and family. In an 
          effort to develop the versatile leaders of tomorrow, we cultivate an 
          environment rich in resilience and diplomacy. This is accomplished 
          through weekly general body meetings, social and professional events, 
          and well-respected guest speakers.
        </p>
        <h1 className="about-constitution-title-1">What we offer</h1>
        <div className="about-constitution-divider"></div>
        <p className="about-constitution-paragraph">
          <span className="about-span-sub">Programming - </span> Many
          first-generation students are unaware of all the resources available
          to them at college. We try to mitigate this by providing extensive
          information on different resourses around campus so that our
          members can access these tools and accell with them.
          <div className="about-spacer"></div>
          <span className="about-span-sub">Mentorship - </span> Every member
          will get paired with their own mentor out of a pool of eager sophmores,
          juniors, and seniors. These mentors will be matched based on each
          member's preferences and will guide them through their journey at UF.
          Many being first-generation students themselves, mentors are equipped
          with the experience of navigating the Univeristy of Florida and are 
          ready to share that knowledge with their mentees.
          <div className="about-spacer"></div>
          <span className="about-span-sub">Socials - </span> We
          understand college can be stressful and overwhelming sometimes. As
          such, we believe it is important to provide cohort members with 
          experiences besides education in order to relieve stress. Socials 
          are meant to give members, who might not have found their place yet, 
          opportunities to socialize, relax, and have fun.
          <div className="about-spacer"></div>
          <span className="about-span-sub">Service - </span> As members
          explore and benefit from the abudance of resources available all around
          Gainesville, they also get a chance to give back to the community.
          Be it through cleaning up the city, assisting community members, 
          helping organize events and the like, members will gain rewarding
          experiences and peace of mind as they help others gain their own peace of mind.
          <div className="about-spacer"></div>
          <span className="about-span-sub">Alumni Network - </span> Connections
          are as important in life as one's own skills and ambitions. We help
          members fulfill this requirement by offering them opportunities to meet
          and interact with the distinguished graduates and alumni of FGLP.
          Alumni are invited to several of our events and members also get access
          to the Alumni Network which further helps connect members to alumni.
          <div className="about-spacer"></div>
          <span className="about-span-sub">Family - </span> College
          is the beginning of so many firsts and one of the hardest for many
          is living apart from family. We understand how lonesome it can be
          and we strive to make sure our organization offers the comfort and
          warmth members may be longing for. We hope that the bonds you form
          here are as long as life, and we guarantee that during our journey
          through college together, FGLP will become your unofficial family
          and your home away from home! 
        </p>
      </Fade>
      <div className="about-member-section">
        <h1 className="about-member-section-title">Ask the members</h1>
        <div className="about-member-section-cards">
          <Fade triggerOnce>
            <div className="about-member-section-card-1">
              <div className="about-member-section-card-top">
                <img
                  src={pic1}
                  alt=""
                  className="about-member-section-card-image"
                ></img>
                <h1 className="about-member-section-card-header">
                  What makes FGLP unique?
                </h1>
              </div>
              <div className="about-member-section-card-bot">
                <div className="about-member-section-card-bot-quote">
                  {" "}
                  "I'd have to say the most unique thing about FGLP is how much
                  every single person genuinely cares about you and wants the best
                  for you. Everyone is always helping one another out and sharing
                  opportunities to further each other's success."
                </div>
                <div className="about-member-section-card-bot-name-1">
                  {" "}
                  - Marcela Bados
                </div>
              </div>
            </div>
            {small ? (
              <></>
            ) : (
              <div className="about-member-section-card-2">
                <div className="about-member-section-card-top">
                  <img
                    src={pic2}
                    alt=""
                    className="about-member-section-card-image"
                  ></img>
                  <h1 className="about-member-section-card-header">
                  What can I expect from FGLP?
                  </h1>
                </div>
                <div className="about-member-section-card-bot">
                  <div className="about-member-section-card-bot-quote">
                    {" "}
                    "You can expect to find your people in FGLP... it's a supportive community 
                    that really gets what it’s like to be first gen. You’ll build confidence, 
                    discover innate leadership skills, and have mentors who are cheering you on
                    every step of the way. Honestly, it feels like a family that wants to see you win."
                  </div>
                  <div className="about-member-section-card-bot-name-2">
                    {" "}
                    - Brandon Martin
                  </div>
                </div>
              </div>
            )}
            {smaller ? (
              <></>
            ) : (
              <div className="about-member-section-card-3">
                <div className="about-member-section-card-top">
                  <img
                    src={pic3}
                    alt=""
                    className="about-member-section-card-image"
                  ></img>
                  <h1 className="about-member-section-card-header">
                    How has FGLP impacted you at UF?
                  </h1>
                </div>
                <div className="about-member-section-card-bot">
                  <div className="about-member-section-card-bot-quote">
                    {" "}
                  "I joined FGLP hoping to find a first-generation community, but I found a family. 
                  From my very first GBM, the e-board remembered the little things about me and always
                  made me feel seen. That’s when I realized I had found a place where I truly belonged at UF. 
                  Today, my closest friends and favorite college memories come from FGLP."
                  </div>
                  <div className="about-member-section-card-bot-name-3">
                    {" "}
                    - Maria Leon
                  </div>
                </div>
              </div>
            )}
          </Fade>
        </div>
      </div>
      <div className="about-faq-div">
        <div className="about-faq-div-title">
          <div className="about-faq-title">Frequently Asked Questions</div>
          <div className="about-faq-divider"></div>
        </div>
        <div className="about-faq-questions">
          <div className="about-faq-question-1">
            <div className="about-faq-question">
              <div className="about-faq-question-header">
                What defines first-generation?
              </div>
              <div className="about-faq-question-content">
                Being first-generation generally means being the 
                first in your family to go to college. More
                specifically, neither parent should have a 
                bachelor's degree nor higher. Under those 
                circumstances, all who are first-generation in
                this country or in college are welcome at FGLP!
              </div>
            </div>
            <div className="about-faq-question">
              <div className="about-faq-question-header">
                Is FGLP only for freshmen?
              </div>
              <div className="about-faq-question-content">
                FGLP is indeed only for incoming freshmen at the University of Florida.
                However, if you're a 2nd year or above you're always welcome to
                apply to become a mentor.
              </div>
            </div>
          </div>
          {smaller ? (
            <></>
          ) : (
            <div className="about-faq-question-2">
              <div className="about-faq-question">
                <div className="about-faq-question-header">
                  When will applications open?
                </div>
                <div className="about-faq-question-content">
                  Applications for the 2026-2027 school year have closed! If you applied and interviewed you will receive your cohort decision on september 8th
                  <br /> 
                  {/*
                     <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSdVPHBZohKH_HsuerGNsAKgdsH9nOtk1HLSLZnTePfsOl2iNg/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="about-faq-application-form"
                  >Apply Here
                  </a>  
                  */}
                </div>
              </div>
              <div className="about-faq-question">
                <div className="about-faq-question-header">
                  Can I apply to be a mentor if I'm not first-generation?
                </div>
                <div className="about-faq-question-content">
                  Yes, you can! You do not need to be first-generation to apply 
                  to be a mentor. All you need is the will to develop a good connection 
                  and a passionate ambition to guide your mentee!
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default About;
